import React from "react";
import styled from "styled-components";
import leanLogo from "../images/leanLogo.svg";

const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: #F4F5F5;
  padding: 16px 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1200px;
`;

const Logo = styled.img`
  height: 32px;
`;

const TopBar = () => {
  return (
    <Wrapper>
      <Inner>
        <Logo src={leanLogo} alt="Lean Logo"></Logo>
      </Inner>
    </Wrapper>
  );
};

export default TopBar;
